"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterTab = function FilterTab(_ref) {
  var style = _ref.style,
      className = _ref.className,
      id = _ref.id,
      title = _ref.title,
      badgeCount = _ref.badgeCount,
      onClick = _ref.onClick,
      onReset = _ref.onReset;

  var handleReset = function handleReset(e) {
    e.stopPropagation();
    onReset();
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    key: id,
    role: "tab",
    tabIndex: "0",
    className: (0, _classnames["default"])('p-2 flex cursor-pointer whitespace-nowrap hover:bg-gray-200 transition duration-300 outline-none', className),
    style: style,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2"
  }, title), badgeCount > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "inline-flex justify-center items-center px-1 rounded text-sm bg-primary text-white font-bold",
    onClick: handleReset
  }, badgeCount, " ", /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterClose, {
    className: "h-4 w-4 fill-primary"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.showTabContent"
  }, function (iconTitle) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "ml-auto",
      title: iconTitle
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ChevronRight, {
      className: "fill-primary"
    }));
  }));
};

FilterTab.propTypes = {
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].node,
  badgeCount: _propTypes["default"].number,
  style: _propTypes["default"].shape({}),
  className: _propTypes["default"].string,
  onReset: _propTypes["default"].func,
  onClick: _propTypes["default"].func
};

var noop = function noop() {};

FilterTab.defaultProps = {
  title: '',
  style: {},
  className: '',
  badgeCount: null,
  onReset: noop,
  onClick: noop
};
var _default = FilterTab;
exports["default"] = _default;